import { Component, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators, ValidationErrors, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../../alert-component';
//import { ELEMENT_MARKER } from '@angular/core/src/render3/interfaces/i18n';
import * as Parse from 'parse';

@Component({
  selector: 'app-activityplan',
  templateUrl: './activityplan.component.html',
  styleUrls: ['./activityplan.component.css'],
})

export class ActivityplanComponent {
    displayedColumns = ['days', 'exercise', 'minutes'];
    dataSource = new MatTableDataSource<Element>();
    @Output() doneSubmiting = new EventEmitter();
    activityPlanSaved : boolean;
    activityplanForm : FormGroup;
    submitted = false;
    successMessage : string;
    failedMessage : string;
    activityFailed : boolean;
    myActivites : any = {};
    ELEMENT_DATA: Element[] = [];
    days = [];
    daysZero = [];

    constructor (
      private router : Router,
      private _bkoffService: BackOffServiceService,
      private modalService: NgbModal,
      private formBuilder : FormBuilder,
      ) {
        Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
        (Parse as any).serverURL = environment.serverURL;
    
    }

    ngOnInit() {  
      this.router.events.subscribe((evt) => {
        window.scrollTo(0, 0)
      });
  

      const r = this.nextWeek();
      for(var i = 0; i < r.length; i++) {
        var d = new Date(r[i]);
        const day = d.getDate();
        const month = this.getFullMonth(d);
        this.days.push(month + " " + day);
      }

      const rt = this.nextWeek();
      for(var i = 0; i < rt.length; i++) {
        var d = new Date(r[i]);
        const day = this.dateDay(d);
        const month = this.dateMonth(d);
        this.daysZero.push(month + "/" + day);
      }



      this.ELEMENT_DATA = [
        { id: this.daysZero[0], days: this.days[0], exercise: '',  minutes: null, },
        { id: this.daysZero[1], days: this.days[1], exercise: '',  minutes: null, },
        { id: this.daysZero[2], days: this.days[2], exercise: '',  minutes: null,},
        { id: this.daysZero[3], days: this.days[3], exercise: '',  minutes: null,},
        { id: this.daysZero[4], days: this.days[4], exercise: '',  minutes: null,},
        { id: this.daysZero[5], days: this.days[5], exercise: '',  minutes: null, },
        { id: this.daysZero[6], days: this.days[6], exercise: '',  minutes: null,},
      ];
      this.dataSource = new MatTableDataSource<Element>(this.ELEMENT_DATA);
    }

    get fmBuilder() { return this.activityplanForm.controls; }

  
    applyFilter(filterValue: string) {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.dataSource.filter = filterValue;
    }

    closeActivityPlan() {
      this.doneSubmiting.emit("saved");
      this.activityPlanSaved = true;
    }

    getFormValidationErrors() {
      // var missingInput = false;
      // Object.keys(this.activityplanForm.controls).forEach(key => {
      // const controlErrors: ValidationErrors = this.activityplanForm.get(key).errors;
      // if (controlErrors != null) {
      //       Object.keys(controlErrors).forEach(keyError => {
      //         console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
      //         if (keyError === "required"){
      //           missingInput = true;
      //         }
      //       });
      //     }
      //   });
      //   return missingInput;
      return false;
      }

    nextWeek() : any {
      var result = [];
      var d = new Date();
      result.push(d.getTime());
      for (var i = 1; i < 8; i++) {
        result.push(d.getTime() + i*86400000);
      }
      return result;
    }

    submitClick(){

      // if (this.activityplanForm.invalid) {
      //   const modalRef = this.modalService.open(NgbdModalContent);
      //   if (this.getFormValidationErrors()){
      //     modalRef.componentInstance.name = 'You have left a question unanswered';
      //   }
      //   else{
      //     modalRef.componentInstance.name = 'Please make sure you have formatted all your inputs correctly';
      //   }
      //     return;
      // }
      // this.submitted = true;
      // const selectedDays = this.activityplanForm.value.days
      //   .map((v, i) => v ? this.days[i].id : null)
      //   .filter(v => v !== null);
      
      console.log(this.ELEMENT_DATA);
      var activityPlanData = new LogsData();
  
      for (var i = 0; i < this.ELEMENT_DATA.length; i++) {
        if (this.ELEMENT_DATA[i].exercise != "") {
          activityPlanData.planactivity = this.ELEMENT_DATA[i].exercise;
          if (this.ELEMENT_DATA[i].minutes === null) {
            activityPlanData.planminutes = "0";
          } else {
            activityPlanData.planminutes = this.ELEMENT_DATA[i].minutes.toString();
          }
          activityPlanData.activitydays = this.ELEMENT_DATA[i].id;
      
          var showedModal = false;
          this._bkoffService.setActivityPlan(activityPlanData).then((success)=>{
            this.doneSubmiting.emit("saved")
            this.activityPlanSaved = true;
            
            if (!showedModal) {
              const modalRef = this.modalService.open(NgbdModalContent);
              modalRef.componentInstance.name = 'Your activity plan has been stored.  It is on your checklist for you to keep track of and update.';
              modalRef.componentInstance.title = 'Success';
              showedModal = true;
            }
      
          }).catch(()=>{
           this.failedMessage  = "Error saving activity plan "
           this.activityFailed = true
           this.activityPlanSaved = false;
           this.sendUserFeedback(this.failedMessage)
           this.doneSubmiting.emit("failed")
           console.log(this.failedMessage)
           return;
          });
  
        }
      }
      this.ELEMENT_DATA = [
        { id: this.daysZero[0], days: this.days[0], exercise: '',  minutes: null, },
        { id: this.daysZero[1], days: this.days[1], exercise: '',  minutes: null, },
        { id: this.daysZero[2], days: this.days[2], exercise: '',  minutes: null,},
        { id: this.daysZero[3], days: this.days[3], exercise: '',  minutes: null,},
        { id: this.daysZero[4], days: this.days[4], exercise: '',  minutes: null,},
        { id: this.daysZero[5], days: this.days[5], exercise: '',  minutes: null, },
        { id: this.daysZero[6], days: this.days[6], exercise: '',  minutes: null,},
      ];

      this.dataSource = new MatTableDataSource<Element>(this.ELEMENT_DATA);
  
    }

    sendUserFeedback(message:string){
    
      const modalRef = this.modalService.open(NgbdModalContent);
      if (!this.activityPlanSaved){
        modalRef.componentInstance.name = 'Error saving data , please try again';
        modalRef.componentInstance.title = 'Unable to submit';
      }
     
    }

    private dateDBFormat(date: Date) {
      var monthString;
      var dayString;
      const day = date.getUTCDay();
      const dayWith = date && date.getDate() || -1;
      const dayWithZero = dayWith.toString().length > 1 ? dayWith : '0' + dayWith;
      const month = date.getMonth() + 1;
      const monthWithZero = month.toString().length > 1 ? month : '0' + month;
      
      switch (day) {
        case 0:
          dayString = "Sunday";
          break;
        case 1:
          dayString = "Monday";
          break;
        case 2:
          dayString = "Tuesday";
          break;
        case 3:
          dayString = "Wednesday";
          break;
        case 4:
          dayString = "Thursday";
          break;
        case 5:
          dayString = "Friday";
          break;
        case 6:
          dayString = "Saturday";
          break;
      }  
      return `${monthWithZero}/${dayWithZero}`;
    }
    dateMonth(date: Date):string {
      const month = date.getMonth() + 1;
      const monthWithZero = month.toString().length > 1 ? month : '0' + month;
      
      return `${monthWithZero}`;
    }

    dateDay(date: Date): string {
      const dayWith = date && date.getDate() || -1;
      const dayWithZero = dayWith.toString().length > 1 ? dayWith : '0' + dayWith;
      
      return `${dayWithZero}`;
    }

    getFullMonth(date: Date) : string {
      const m = date.getMonth();
      switch (m) {
        case 0:
          return "January";
          break;
        case 1:
          return "February";
          break;
        case 2:
          return "March";
          break;
        case 3:
          return "April";
          break;
        case 4:
          return "May";
          break;
        case 5:
          return "June";
          break;
        case 6:
          return "July";
          break;
        case 7:
          return "August";
          break;
        case 8:
          return "September";
          break;
        case 9:
          return "October";
          break;
        case 10:
          return "November";
          break;
        case 11:
          return "December";
          break;
        default:
          return "";
      }
    }

  }

  export interface Element {
    id: string;
    days: string;
    exercise: string;
    minutes: number;

  }
  
